
import Swift from '../Components/img/iconbar/suzuki.ico'
import Tempo from './img/iconbar/tempotrav.ico'
import innova from './img/iconbar/toy.ico'
import Crysta from './img/iconbar/crysta.ico'
import Tovera from './img/iconbar/toverp.ico'
import Etios from './img/iconbar/etios.ico'
const Sdata=[

    {    
        img: Swift, 
        Title:"Swift Dzire",
        Ctext:"Occupancy :4 Seats",


},
{    
    img: Etios, 
    Title:"Etios",
    Ctext:"Occupancy :4 Seats",


},
{    
    img: innova, 
    Title:"Innova",
    Ctext:"Occupancy :7 Seats",


},
{    
    img: Crysta, 
    Title:"Crysta",
    Ctext:"Occupancy :7 Seats",


},    {    
    img: Tovera, 
    Title:"Tovera",
    Ctext:"Occupancy :7 Seats",


},
    {    
    img: Tempo, 
    Title:"Tempo Trav",
    Ctext:"Occupancy :12 Seats",


}

]
export default Sdata;